var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-area"},[_c('p',{staticClass:"large-bold-text card-text"},[_vm._v("SamplePage!")])])}]

export { render, staticRenderFns }